import type React from 'react';
import classes from './phone-cell.module.scss';

export const PhoneCell: React.FC<{ value: string | null }> = ({ value }) => {
  if (!value) {
    return <span className={classes.mutedValue}>—</span>;
  }

  return (
    <button
      type="button"
      className={classes.phoneValue}
      onClick={() => {
        if (navigator?.clipboard?.writeText) {
          void navigator.clipboard.writeText(value);
        }
      }}
      title="לחצו להעתקה"
    >
      {value}
    </button>
  );
};
